const actions = {
  // Page Roles Actions
  GET_PAGE_ROLES: 'RBAC/PAGE_ROLES/GET_PAGE_ROLES',
  GET_PAGE_ROLES_SUCCESS: 'RBAC/PAGE_ROLES/GET_PAGE_ROLES_SUCCESS',
  GET_PAGE_ROLES_ERROR: 'RBAC/PAGE_ROLES/GET_PAGE_ROLES_ERROR',
  CREATE_PAGE_ROLE: 'RBAC/PAGE_ROLES/CREATE_PAGE_ROLE',
  CREATE_PAGE_ROLE_SUCCESS: 'RBAC/PAGE_ROLES/CREATE_PAGE_ROLE_SUCCESS',
  CREATE_PAGE_ROLE_ERROR: 'RBAC/PAGE_ROLES/CREATE_PAGE_ROLE_ERROR',
  UPDATE_PAGE_ROLE: 'RBAC/PAGE_ROLES/UPDATE_PAGE_ROLE',
  UPDATE_PAGE_ROLE_SUCCESS: 'RBAC/PAGE_ROLES/UPDATE_PAGE_ROLE_SUCCESS',
  UPDATE_PAGE_ROLE_ERROR: 'RBAC/PAGE_ROLES/UPDATE_PAGE_ROLE_ERROR',
  DELETE_PAGE_ROLE: 'RBAC/PAGE_ROLES/DELETE_PAGE_ROLE',
  DELETE_PAGE_ROLE_SUCCESS: 'RBAC/PAGE_ROLES/DELETE_PAGE_ROLE_SUCCESS',
  DELETE_PAGE_ROLE_ERROR: 'RBAC/PAGE_ROLES/DELETE_PAGE_ROLE_ERROR',
  CLEAR_PAGE_ROLES_ERROR: 'RBAC/PAGE_ROLES/CLEAR_PAGE_ROLES_ERROR',

  // Action Creators
  getPageRoles: (options = {}) => ({
    type: actions.GET_PAGE_ROLES,
    options,
  }),
  getPageRolesSuccess: (pageRoles, pagination) => ({
    type: actions.GET_PAGE_ROLES_SUCCESS,
    pageRoles,
    pagination,
  }),
  getPageRolesError: (error) => ({
    type: actions.GET_PAGE_ROLES_ERROR,
    error,
  }),
  createPageRole: (roleData) => ({
    type: actions.CREATE_PAGE_ROLE,
    roleData,
  }),
  createPageRoleSuccess: (pageRole) => ({
    type: actions.CREATE_PAGE_ROLE_SUCCESS,
    pageRole,
  }),
  createPageRoleError: (error) => ({
    type: actions.CREATE_PAGE_ROLE_ERROR,
    error,
  }),
  updatePageRole: (roleId, roleData) => ({
    type: actions.UPDATE_PAGE_ROLE,
    roleId,
    roleData,
  }),
  updatePageRoleSuccess: (pageRole) => ({
    type: actions.UPDATE_PAGE_ROLE_SUCCESS,
    pageRole,
  }),
  updatePageRoleError: (error) => ({
    type: actions.UPDATE_PAGE_ROLE_ERROR,
    error,
  }),
  deletePageRole: (roleId) => ({
    type: actions.DELETE_PAGE_ROLE,
    roleId,
  }),
  deletePageRoleSuccess: (roleId) => ({
    type: actions.DELETE_PAGE_ROLE_SUCCESS,
    roleId,
  }),
  deletePageRoleError: (error) => ({
    type: actions.DELETE_PAGE_ROLE_ERROR,
    error,
  }),
  clearPageRolesError: () => ({
    type: actions.CLEAR_PAGE_ROLES_ERROR,
  }),
};

export default actions;
